import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../../../components/card/card.jsx";
import Degradation from "./chart";
import { useParams } from "react-router-dom";
function MachineList({ recalculateRandom, allData }) {
  let { assetId } = useParams();
  return (
    <Card className="bg-blue-900 border-theme  mb-3">
      <CardBody>
        <h4>OPEX </h4>
        <div class="row">
          <div class="col-sm-12">
            <div style={{ padding: "10px" }}>
              <Degradation
                allData={allData}
                assetId={assetId}
                calculateValue={recalculateRandom}
              />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default MachineList;
